import {Component, OnInit} from '@angular/core';
import {encodingClothsImages} from '../cloths-mockup';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';
import {encodingSymbolsImages, encodingSymbolsString} from '../symbols-mockup';
import {GeneralDragAndDropExerciseComponent} from '../../General/g-drag-and-drop-exercise';

@Component({
  selector: 'app-repair-encoding',
  templateUrl: './repair-encoding.component.html',
  styleUrls: ['./repair-encoding.component.css']
})
export class RepairEncodingComponent extends GeneralDragAndDropExerciseComponent implements OnInit {

  encodings: number[][] = [];
  currentClickedSolutions: number[][] = [];
  currentClickedSolutionsIdx: number[] = [];
  currentDropIdx: number;
  numberOfSolutions = 0;
  defectCode: number [] = [];
  clothsImages = encodingClothsImages;
  symbolImages = encodingSymbolsImages;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  ngOnInit() {
    super.ngOnInit();
    this.setAllDragElementIds();
  }

  initValues() {
    super.initValues();
    this.encodings = [];
    this.defectCode = [];
    this.currentClickedSolutions = [];
    this.currentClickedSolutionsIdx = [];
    this.currentDropIdx = -1;
    this.numberOfSolutions = 0;
    this.solved = false;
    this.setAllDragElementIds();
  }

  checkSolution() {
    if (this.currentClickedSolutionsIdx[this.currentDropIdx] === -1){
      if (this.countOccurencesOf(this.currentClickedSolutions[this.currentDropIdx], this.encodings) !== 0 &&
        this.countOccurencesOf(this.currentClickedSolutions[this.currentDropIdx], this.currentClickedSolutions) === 1) {
        this.currentClickedSolutionsIdx[this.currentDropIdx] = this.getIndexOf(this.currentClickedSolutions[this.currentDropIdx], this.encodings);

        let countSolutions = 0;
        for (let i = 0; i < this.numberOfSolutions; i++) {
          if (this.currentClickedSolutionsIdx[i] !== -1) {
            countSolutions ++;
          }
        }

        if (this.numberOfSolutions === countSolutions) {
          this.messageService.addAlertWithTimeout(this.get('correctlyDecoded'), 'success', 1000);
          this.isSolvedImageVisible = true;
          this.solved = true;
          setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
          this.saveState();
        } else {
          this.isSolvedImageVisible = true;
          setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
        }
      } else if (!this.compareArrays(this.currentClickedSolutions[this.currentDropIdx], this.defectCode)) {
        this.currentClickedSolutions[this.currentDropIdx] = Object.assign([], this.defectCode);
        this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
      }
    }
  }

  isSolved(i: number) {
    return this.countOccurencesOf(this.currentClickedSolutions[i], this.encodings) !== 0;
  }

  getIndexOf (code: number[], encodings: number[][]) {
    for (let i = 0; i < encodings.length; i++) {
      let isSame = true;
      for (let j = 0; j < encodings[i].length; j++) {
        if (encodings[i][j] !== code[j]) {
          isSame = false;
        }
      }
      if (isSame) {
        return i;
      }
    }
    return -1;
  }

  countOccurencesOf (code: number[], encodings: number[][]) {
    let counter = 0;
    for (let i = 0; i < encodings.length; i++) {
      let isSame = true;
      for (let j = 0; j < encodings[i].length; j++) {
        if (encodings[i][j] !== code[j]) {
          isSame = false;
        }
      }
      if (isSame) {
        counter ++;
      }
    }
    return counter;
  }

  generateNextExercise() {
    this.counter ++;
    this.initValues();
    console.log(this.solved);
  }

  /**
   * Set the encodings
   * Now it is possible to create a defect encodings from the encodings.
   * Then it is also count how many possible solution the defect encodings can have.
   * @param encoding from the symbols encodings random
   */
  setEncoding(encoding: number[][]) {
    this.encodings = encoding;
    this.setDefectCode();
    this.setSolutionCounter();
  }

  setAllDragElementIds() {
    this.allDragElementIds = encodingSymbolsString;
  }

  setDefectCode() {
    let result = [];
    while (result.length === 0) {
      const randEncodingIdx = Math.floor((Math.random() * this.encodings.length));
      const randIdx = Math.floor((Math.random() * this.encodings[randEncodingIdx].length));

      const temp = [];

      for (let i = 0; i < this.encodings[randEncodingIdx].length; i++) {
        if (i !== randIdx) {
          temp.push(this.encodings[randEncodingIdx][i]);
        } else {
          if (this.encodings[randEncodingIdx][i] === 0) {
            temp.push(1);
          } else {
            temp.push(0);
          }
        }
      }

      if (this.countOccurencesOf(temp, this.encodings) === 0) {
        result = temp;
      }
    }

    this.defectCode = result;
  }

  setSolutionCounter() {
    let counter = 0;
    for (let i = 0; i < this.defectCode.length; i++) {
      const temp = Object.assign([], this.defectCode);
      if (temp[i] === 0) {
        temp[i] = 1;
      } else {
        temp[i] = 0;
      }

      if (this.countOccurencesOf(temp, this.encodings) !== 0) {
        this.currentClickedSolutions[counter] = Object.assign([], this.defectCode);
        this.currentClickedSolutionsIdx[counter] = -1;
        counter++;
      }
    }
    this.numberOfSolutions = counter;
  }

  onMouseUp(event) {
    if (this.currentDragElementId !== null) {
      if (this.currentBelowElement !== null) {
        for (let i = 0; i < this.allDragElementIds.length; i++) {
          if (this.currentDragElementId.value === this.allDragElementIds[i]) {
            const x = Math.floor(parseInt(this.currentBelowElement.id, 10) / this.defectCode.length);
            const y = (parseInt(this.currentBelowElement.id, 10) % this.defectCode.length);
            this.currentDropIdx = x;
            this.currentClickedSolutions[x][y] = i;
            break;
          }
        }
      }
      this.currentBelowElement = null;

      this.currentDragElementId.ownerElement.style.position = '';
      this.currentDragElementId.ownerElement.style.left = '';
      this.currentDragElementId.ownerElement.style.top = '';
      this.currentDragElementId.ownerElement.style.zIndex = 3;
      this.currentDragElementId.ownerElement.style.width = '';
      this.currentDragElementId = null;

      this.checkSolution();
    }
  }

  getHidden(id: string) {
    if (this.currentDragElementId === null) {
      return true;
    }

    return !(this.currentDragElementId.value === id);
  }

  getActive(i: number) {
    return this.currentBelowElement !== null && parseInt(this.currentBelowElement.id, 10) === i;
  }

  getImageSrc(idx) {
    return this.symbolImages[idx];
  }

  getClothsImage(i: number) {
    if (this.currentClickedSolutionsIdx[i] !== -1) {
      return this.clothsImages[this.currentClickedSolutionsIdx[i]];
    }
  }

  getNumberOfEncodings() {
    if (this.level === 1) {
      return 2;
    } else if (this.level === 2) {
      return 3;
    } else {
      return 3;
    }
  }

  getMaxSizeTable() {
    return 70;
  }

  getDragElementMaxSize() {
    return Math.max( Math.min((this.getMaxSizeTable() / this.encodings[0].length), 26), 14);
  }

  setTypeSpecificsFromConfiguration() {
  }

  setTypeSpecificsFromState() {
    if (this.state) {
      if (this.state.counter) {
        this.counter = this.state.counter;
      }
    }
  }

  computeState() {
    this.state.counter = this.counter;
  }

}
